import { render, staticRenderFns } from "./circle.vue?vue&type=template&id=025f9d63&scoped=true&"
import script from "./circle.vue?vue&type=script&lang=ts&"
export * from "./circle.vue?vue&type=script&lang=ts&"
import style0 from "./circle.vue?vue&type=style&index=0&id=025f9d63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025f9d63",
  null
  
)

export default component.exports